export const PARSER_RESULT_STATUS = {
    EMPTY_STATE_PAGE: 'empty_state_page',
    ERROR: 'error',
    SUCCESS: 'success',
};
export const PARSER_CATEGORIES = {
    PROFILE: 'profile',
    BULK: 'bulk_profile',
    COMPANY: 'company',
};
export const PARSER_TYPES = {
    LINKEDIN: {
        RECRUITER_PRO_PROFILE: 'LI Recruiter Pro',
    },
};
